import _ from 'lodash'

import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const MEDICATION_CATEGORY = 'medication'

const mappingBasic = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'AllergyIntolerance'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'recordedDate' ],
    form: [ 'recordedDate' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'reaction', 0, 'manifestation', 0, 'text' ],
    form: [ 'reaction' ]
  },
  {
    fhir: [ 'reaction', 0, 'description' ],
    form: [ 'reaction' ]
  },
  {
    fhir: [ 'type' ],
    fhir_const: 'allergy'
  },
  {
    fhir: [ 'criticality' ],
    form: [ 'severity' ]
  },
  {
    fhir: [ 'status' ],
    form: [ 'status' ]
  },
  {
    fhir: [ 'category' ],
    form: [ 'category' ]
  }
]

const mappingMedication = mappingBasic.concat([
  {
    fhir: [ 'reaction', 0, 'substance', 'text' ],
    form: [ 'coding', 'display' ]
  },
  {
    fhir: [ 'reaction', 0, 'substance', 'coding', 0 ],
    form: [ 'coding' ]
  },
  {
    fhir: [ 'reaction', 0, 'substance', 'coding', 0, 'system' ],
    fhir_const: 'http://www.nlm.nih.gov/research/umls/rxnorm'
  }
])

const mappingFreeText = mappingBasic.concat([
  {
    fhir: [ 'reaction', 0, 'substance', 'text' ],
    form: [ 'freeText' ]
  }
])

const getMapping = data =>
  (data.category === MEDICATION_CATEGORY ? mappingMedication : mappingFreeText)

export function toFHIR (data, patientId) {
  _.unset(data, 'coding._tty')
  const res = transform(data, getMapping(data), [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${patientId}` }
  res.patient = ptRef
  res.reporter = ptRef
  return res
}

export function fromFHIR (data) {
  return transform(data, getMapping(data), [ 'fhir', 'form' ])
}
